import { gsap } from "gsap";
import { useEffect } from "react";

export function useDataWIdAnimation31() {
  useEffect(() => {
    gsap.set('[data-w-id="088680cd-e9fc-99b1-bda8-4c3b0f78aa9c"]', {"opacity": 0});
                const tl = gsap.timeline({"scrollTrigger": {"trigger": "[data-w-id=\"088680cd-e9fc-99b1-bda8-4c3b0f78aa9c\"]", "start": "top 70%", "end": "bottom top", "toggleActions": "play none none none", "once": true}});
      tl.addLabel("label0");
      tl.to('[data-w-id="088680cd-e9fc-99b1-bda8-4c3b0f78aa9c"]', {"duration": 0.5, "delay": 0.2, "ease": "power1.inOut", "opacity": 1}, "label0");
    return () => {
      tl.kill();
    };
  }, []);
}